import { render, staticRenderFns } from "./IframeContent.vue?vue&type=template&id=1d706f48"
import script from "./IframeContent.vue?vue&type=script&lang=js"
export * from "./IframeContent.vue?vue&type=script&lang=js"
import style0 from "./IframeContent.vue?vue&type=style&index=0&id=1d706f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports